import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { __rest } from "tslib";
import * as React from 'react';
import { Form } from '../..';
import { ClassNames } from '../../utils/classNames';
import { Icon, IconUtils } from '../icon';
import { IconButton } from '../iconButton';
import { InputWrapper } from '../inputWrapper';
/** A select input which takes an array of options */

export var Select = React.forwardRef(function (_a, ref) {
  var _b, _c;

  var bind = _a.bind,
      options = _a.options,
      leftIcon = _a.leftIcon,
      leftOverlay = _a.leftOverlay,
      rightIcon = _a.rightIcon,
      rightOverlay = _a.rightOverlay,
      className = _a.className,
      onSelectOption = _a.onSelectOption,
      onChange = _a.onChange,
      value = _a.value,
      validationErrorIcon = _a.errorIcon,
      validationErrorMessages = _a.validationErrorMessages,
      validationMode = _a.validationMode,
      selectOverlayIcon = _a.selectOverlayIcon,
      pending = _a.pending,
      disabled = _a.disabled,
      deleteButton = _a.deleteButton,
      disableOnPending = _a.disableOnPending,
      scrollValidationErrorsIntoView = _a.scrollValidationErrorsIntoView,
      placeholderOption = _a.placeholderOption,
      statusPosition = _a.statusPosition,
      placeholderOptionEnabled = _a.placeholderOptionEnabled,
      hideIconOnStatus = _a.hideIconOnStatus,
      nativeProps = __rest(_a, ["bind", "options", "leftIcon", "leftOverlay", "rightIcon", "rightOverlay", "className", "onSelectOption", "onChange", "value", "errorIcon", "validationErrorMessages", "validationMode", "selectOverlayIcon", "pending", "disabled", "deleteButton", "disableOnPending", "scrollValidationErrorsIntoView", "placeholderOption", "statusPosition", "placeholderOptionEnabled", "hideIconOnStatus"]);

  var internalRef = React.useRef(null);
  React.useImperativeHandle(ref, function () {
    return internalRef.current;
  }, [internalRef]);

  var _Form$useBindingState = Form.useBindingState(bind, {
    value: value,
    validationErrorMessages: validationErrorMessages
  }),
      _Form$useBindingState2 = _slicedToArray(_Form$useBindingState, 3),
      boundValue = _Form$useBindingState2[0],
      setBoundValue = _Form$useBindingState2[1],
      bindConfig = _Form$useBindingState2[2];

  var clearSelect = React.useCallback(function () {
    var _a;

    onSelectOption === null || onSelectOption === void 0 ? void 0 : onSelectOption(undefined);
    (_a = bind === null || bind === void 0 ? void 0 : bind.setValue) === null || _a === void 0 ? void 0 : _a.call(bind, undefined);
  }, [onSelectOption, bind === null || bind === void 0 ? void 0 : bind.setValue]);
  var onChangeEvent = React.useCallback(function (event) {
    if (onChange) {
      onChange(event);
    }

    var newValue = event.currentTarget.value;
    var selectedOption = options.find(function (option) {
      var _a;

      return ((_a = option.id) === null || _a === void 0 ? void 0 : _a.toString()) === newValue;
    });

    if (selectedOption) {
      setBoundValue === null || setBoundValue === void 0 ? void 0 : setBoundValue(selectedOption.id);
      onSelectOption === null || onSelectOption === void 0 ? void 0 : onSelectOption(selectedOption);
    } else if (!newValue && placeholderOption && placeholderOptionEnabled) {
      clearSelect();
    }
  }, [onSelectOption, options, onChange, bind, placeholderOption, placeholderOptionEnabled, clearSelect, setBoundValue]);
  return React.createElement(InputWrapper, {
    className: ClassNames.concat('arm-select', className),
    leftIcon: leftIcon,
    rightIcon: rightIcon,
    leftOverlay: leftOverlay,
    rightOverlay: rightOverlay,
    validationErrorMessages: bindConfig.validationErrorMessages,
    errorIcon: validationErrorIcon || ((_b = bind === null || bind === void 0 ? void 0 : bind.formConfig) === null || _b === void 0 ? void 0 : _b.validationErrorIcon),
    validationMode: validationMode || ((_c = bind === null || bind === void 0 ? void 0 : bind.formConfig) === null || _c === void 0 ? void 0 : _c.validationMode),
    pending: pending,
    disabled: disabled,
    disableOnPending: disableOnPending,
    scrollValidationErrorsIntoView: scrollValidationErrorsIntoView,
    statusPosition: statusPosition,
    hideIconOnStatus: hideIconOnStatus
  }, React.createElement("div", {
    className: "arm-select-inner"
  }, React.createElement("select", Object.assign({
    className: "arm-select-select"
  }, nativeProps, {
    ref: internalRef,
    onChange: onChangeEvent,
    value: boundValue !== null && boundValue !== void 0 ? boundValue : undefined,
    disabled: disabled,
    defaultValue: placeholderOption && !nativeProps.defaultValue && !boundValue ? '' : nativeProps.defaultValue
  }), placeholderOption && React.createElement("option", {
    value: "",
    disabled: !placeholderOptionEnabled
  }, placeholderOption), options.map(function (option) {
    var _a;

    return React.createElement("option", Object.assign({
      key: option.id,
      value: (_a = option.id) !== null && _a !== void 0 ? _a : undefined,
      disabled: option.disabled
    }, option.htmlProps), option.name || option.id);
  })), selectOverlayIcon && (IconUtils.isIconDefinition(selectOverlayIcon) ? React.createElement(Icon, {
    className: "arm-select-overlay-icon",
    icon: selectOverlayIcon.icon,
    iconSet: selectOverlayIcon.iconSet
  }) : selectOverlayIcon)), deleteButton && boundValue && React.createElement(IconButton, {
    type: "button",
    className: "arm-select-delete",
    onClick: function onClick(event) {
      clearSelect();
      event.stopPropagation();
    },
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    },
    icon: typeof deleteButton === 'boolean' ? IconUtils.getIconDefinition('Icomoon', 'cross2') : deleteButton,
    minimalStyle: true
  }));
} // type assertion to ensure generic works with RefForwarded component
// DO NOT CHANGE TYPE WITHOUT CHANGING THIS, FIND TYPE BY INSPECTING React.forwardRef
);
Select.defaultProps = {
  selectOverlayIcon: IconUtils.getIconDefinition('Icomoon', 'arrow-down3')
};